<template>
  <div class="ui-header flex">
    <div class="logo" @click="() => handleSelect('/')">SecBench网络安全大模型评测</div>
    <el-menu
      :default-active="activeIndex"
      text-color="#666"
      active-text-color="#0064ff"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/dataset">数据集</el-menu-item>
      <el-menu-item index="/board">排行榜</el-menu-item>
      <!--el-menu-item index="/contributor">贡献榜</el-menu-item-->
      <el-menu-item index="/challenge">挑战赛</el-menu-item>
      <el-menu-item index="https://arxiv.org/abs/2412.20787">技术文章</el-menu-item>
      <!-- el-menu-item index="5">
        <a href="http://ll.oa.com/plugin" target="_blank">插件中心</a>
      </el-menu-item -->
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '/',
    };
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
    },
  },
  methods: {
    handleSelect(page) {
      this.activeIndex = page;
      if (page.includes('http')) {
        window.open(page, '_blank');
      } else {
        this.$router.push({
          path: page || `/`,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/_var.less';
@logo-width: 140px;
/deep/.el-badge__content.is-fixed {
  top: 10px;
  background: rgb(255, 53, 37);
  font-size: 8px;
  font-weight: 600;
  font-family: PingFang SC;
  padding: 0 5px;
  border-radius: 10px;
  height: 14px;
  line-height: 14px;
}
.menu-item() {
  height: calc(@header-height - 1px);
  line-height: calc(@header-height - 1px);
  padding: 0;
  margin: 0 20px;
  background: @header-background !important;
  font-size: 14px;
}

.ui-header {
  background-color: @header-background;
  border-bottom: 1px solid #e7eaef;
  height: @header-height;
  line-height: @header-height;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 13;
  min-width: @body-min-width;
  //padding: 0 @padding;
  .logo {
    background-image: url('../assets/images/logo.png');
    background-size: 24px 28px;
    background-repeat: no-repeat;
    background-position-y: 50%;
    padding-left: 30px;
    // margin-top: 10px;
    float: left;
    margin-left: 32px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    font-family: PingFang SC;
    line-height: 48px;
  }
  .el-menu {
    display: inline-block;
    //margin-left: calc(@padding - @logo-padding - @logo-width);
    margin-left: 60px;
    &.el-menu--horizontal {
      background-color: @header-background;
      border-bottom: none;
      .el-menu-item {
        .menu-item;
        margin: 0 15px;
        a {
          text-decoration: none;
          display: inline-block;
          margin-top: -4px !important;
          //.menu-item;
        }
      }
      & > .el-submenu {
        .el-submenu__title {
          .menu-item;
        }
      }
    }
  }
}
</style>
